enum ProductInformationSectionModalEnum {
	productDetailsCard = 'productDetailsCard',
	technicalInformationCard = 'technicalInformationCard',
	measurementsCard = 'measurementsCard'
}

export default ProductInformationSectionModalEnum;
